import forge from "node-forge";
import { public_key } from "../../keys";

async function encryptApi(code){
    
    const publicKey = forge.pki.publicKeyFromPem(public_key);
        const encrypted = publicKey.encrypt(code, 'RSA-OAEP');
         console.log(forge.util.encode64(encrypted))
         const ciphertext = forge.util.encode64(encrypted)

         console.log(ciphertext)

         return ciphertext
}

export default encryptApi;